import { PageUrl } from '../../../constants/PageUrl';

const BLOG_PATH_PREFIX = PageUrl.BLOG_ROOT;

export const getArticleSlug = (): string | undefined => {
  const normalizedPath = window.location.pathname.replace(/\/+$/, '');
  if (!normalizedPath.startsWith(BLOG_PATH_PREFIX)) {
    return undefined;
  }

  const articleSlug = normalizedPath.slice(BLOG_PATH_PREFIX.length);
  return articleSlug.length > 0 ? articleSlug : undefined;
};
